// extracted by mini-css-extract-plugin
export var emailInput = "emailForm-module--emailInput--0fb43";
export var emailSubmit = "emailForm-module--emailSubmit--55084";
export var form = "emailForm-module--form--dab96";
export var message = "emailForm-module--message--f3fcb";